// src/components/TestOverBlock.jsx
import React from "react";
import TStyles from "../styles/TestStyles.module.css";
import GenStyles from "../styles/GenStyles.module.css";

const TestOverBlock = ({
                           whichTest,
                           totalTestTimeSec = 0,
                           totalQuestions = 0,
                           answeredCount = 0,
                           wordCount = 0,
                           onReview = null,
                           onFinish = null,
                           onRetake = null,
                           children, // optional: inject custom content
                       }) => {
    const formatSeconds = (s) => {
        const m = Math.floor(s / 60);
        const sec = s % 60;
        if (m === 0) return `${sec} ${sec === 1 ? "second" : "seconds"}`;
        if (sec === 0) return `${m} ${m === 1 ? "minute" : "minutes"}`;
        return `${m} ${m === 1 ? "minute" : "minutes"} ${sec} ${sec === 1 ? "second" : "seconds"}`;
    };

    return (
        <div className={TStyles.testOver_card} role="region" aria-label="Test complete">
            <div className={TStyles.testOver_header}>
                <div className={TStyles.testOver_badge}>Test Complete</div>
                <h2 className={TStyles.testOver_title}>Great job—your {whichTest} test is finished.</h2>
                {/*<p className={TStyles.testOver_subtitle}>*/}
                {/*    You can review your answers or submit and exit.*/}
                {/*</p>*/}
            </div>

            {/*<ul className={TStyles.testOver_stats} aria-label="Test summary">*/}
            {/*    <li className={TStyles.testOver_statItem}>*/}
            {/*        <span className={TStyles.testOver_statLabel}>Total time</span>*/}
            {/*        <span className={TStyles.testOver_statValue}>{formatSeconds(totalTestTimeSec)}</span>*/}
            {/*    </li>*/}
            {/*    <li className={TStyles.testOver_statItem}>*/}
            {/*        <span className={TStyles.testOver_statLabel}>Questions answered</span>*/}
            {/*        <span className={TStyles.testOver_statValue}>{answeredCount} / {totalQuestions}</span>*/}
            {/*    </li>*/}
            {/*    <li className={TStyles.testOver_statItem}>*/}
            {/*        <span className={TStyles.testOver_statLabel}>Estimated words</span>*/}
            {/*        <span className={TStyles.testOver_statValue}>{wordCount}</span>*/}
            {/*    </li>*/}
            {/*</ul>*/}

            {children ? <div className={TStyles.testOver_custom}>{children}</div> : null}

            <div className={TStyles.testOver_actions}>
                {onReview && (
                    <button type="button" className={TStyles.btn_ghost} onClick={onReview}>
                        Review Answers
                    </button>
                )}
                {onRetake && (
                    <button type="button" className={TStyles.btn_ghost} onClick={onRetake}>
                        Start Over
                    </button>
                )}
                {onFinish && (
                    <button type="button" className={TStyles.exitButton} onClick={onFinish} autoFocus>
                        Exit
                    </button>
                )}
            </div>
        </div>
    );
};

export default TestOverBlock;
